import PageOverlayModule from './Module';

const pageOverlayModule = reactive(new PageOverlayModule());
export function usePageOverlay() {
    return pageOverlayModule;
}
